import { withBlockExtensions } from '@plone/volto/helpers';
import cx from 'classnames';
import { useState } from 'react';
import { Timeline } from 'react-twitter-widgets';

const TwitterSkeleton = () => {
  return (
    <div className="twitter-skeleton">
      <div className="twitter-skeleton-header">
        <div className="twitter-skeleton-avatar"></div>
        <div className="twitter-skeleton-info">
          <div className="twitter-skeleton-name"></div>
          <div className="twitter-skeleton-handle"></div>
        </div>
      </div>

      {[1, 2, 3].map((item) => (
        <div key={item} className="twitter-skeleton-tweet">
          <div className="twitter-skeleton-content">
            <div className="twitter-skeleton-text"></div>
            <div className="twitter-skeleton-text"></div>
            <div className="twitter-skeleton-text short"></div>
          </div>
          <div className="twitter-skeleton-actions">
            <div className="twitter-skeleton-action"></div>
            <div className="twitter-skeleton-action"></div>
            <div className="twitter-skeleton-action"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

const TwitterView = (props) => {
  const { className, data } = props;
  const twitter_username = data.twitter_username;
  const [isLoading, setIsLoading] = useState(true);

  if (!twitter_username) {
    return <div className={cx('block', className)}>No twitter username</div>;
  }

  return (
    <>
      {data && (
        <div className={cx('block', className)}>
          {isLoading && <TwitterSkeleton />}
          <Timeline
            dataSource={{
              sourceType: 'url',
              screenName: twitter_username,
            }}
            options={{
              height: '400',
              tweetLimit: '10',
            }}
            onLoad={() => setIsLoading(false)}
          />
        </div>
      )}
    </>
  );
};

export default withBlockExtensions(TwitterView);
